var _defs, _rect, _path, _polygon, _path2, _path3, _path4, _polygon2, _polygon3, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg14(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    "data-name": "\\u56FE\\u5C42 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;opacity:0;}.cls-2{fill:#2c2933;}.cls-3{fill:#7333ff;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.14,
    y: -0.28,
    width: 1080,
    height: 400
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M539.46,169.08c-11.25,0-21.74,4.49-28.07,12l-2.15,2.55v-13H491.52V266h17.72V211.48c0-17.34,9.65-27.7,25.8-27.7s25.62,10.36,25.62,27.7V266H578.2V208.54C578.2,184.2,563.36,169.08,539.46,169.08Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "356.73 266.17 375.13 266.17 375.13 204.44 433.13 204.44 433.13 187.51 375.13 187.51 375.13 156.14 434.63 156.14 434.63 137.74 356.73 137.74 356.73 266.17"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M966.82,170.68v10.06a48,48,0,0,0-31.4-11.66c-26.83,0-48.57,22-48.57,49.15s21.74,49.15,48.57,49.15a48,48,0,0,0,31.4-11.66V266H984V170.68Zm-31.4,80.89c-18.06,0-32.76-15-32.76-33.34s14.7-33.34,32.76-33.34,32.77,15,32.77,33.34S953.49,251.57,935.42,251.57Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M676.32,180.83A48,48,0,0,0,645,169.08h-.14c-26.76,0-48.5,21.91-48.57,49s21.6,49.21,48.43,49.29h.14a48,48,0,0,0,31.29-11.57l0,10.29,17.18,0,.38-128.38-17.18-.05Zm-31.51,70.74h-.09a32.29,32.29,0,0,1-23.08-9.77,33.37,33.37,0,0,1-9.59-23.66c.05-18.34,14.75-33.25,32.76-33.25h.1A32.25,32.25,0,0,1,668,194.65a33.42,33.42,0,0,1,9.6,23.67C677.52,236.66,662.83,251.57,644.81,251.57Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M759.63,169.08c-26.82,0-48.57,22-48.57,49.15s21.75,49.15,48.57,49.15,48.58-22,48.58-49.15S786.46,169.08,759.63,169.08Zm0,82.49c-18.06,0-32.76-15-32.76-33.34s14.7-33.34,32.76-33.34,32.77,15,32.77,33.34S777.7,251.57,759.63,251.57Z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "451.81 224.47 451.81 249.21 451.81 265.81 470.45 265.81 470.45 170.39 451.81 170.39 451.81 224.47"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "451.81 147.2 451.81 152.01 451.81 156.14 470.45 156.14 470.45 137.74 451.81 137.74 451.81 147.2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M874.49,169.78c-19.53,0-27.49,11.53-30.22,18.62V170.89H825.63v94.92h18.64V217c0-9,1.39-19.47,13.09-27.13,10.69-7,23.62-4.75,23.62-4.75V170.28C879.76,169.76,875.86,169.78,874.49,169.78Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M142.84,132.81a2.18,2.18,0,0,0,2.67,1.54l100-26.8a2.18,2.18,0,0,0-.37-4.28L135.31,93.41a2.18,2.18,0,0,0-2.3,2.73Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M152.81,198.33l-14.59-54.45h0l-1.9-7.07h0l-7.77-29a2.19,2.19,0,0,0-4.22,0l-28,104.54A2.18,2.18,0,0,0,99,215l52.25-14A2.16,2.16,0,0,0,152.81,198.33Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M274.33,113a7.26,7.26,0,0,0-8.15-3.38L147.4,141.42a2.18,2.18,0,0,0-1.54,2.67l14,52.35a2.18,2.18,0,0,0,2.67,1.54L299.1,161.39a2.18,2.18,0,0,0,1.33-3.19Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M155.84,209.62a2.18,2.18,0,0,0-2.67-1.54l-52.29,14a2.18,2.18,0,0,0-1,3.64l76.77,77.38a2.18,2.18,0,0,0,3.66-2.1Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M294.69,170.16l-130.24,34.9a2.17,2.17,0,0,0-1.54,2.66l25.92,96.71a2.18,2.18,0,0,0,3.81.79L297,173.62A2.18,2.18,0,0,0,294.69,170.16Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg14);
export default __webpack_public_path__ + "static/media/14.6d63fa724d98fb8331f3291b6874014d.svg";
export { ForwardRef as ReactComponent };